import { type ReactElement } from 'react';
import CTNSpinner from '@ctn/ui/components/ctn-spinner';

const Loader = (): ReactElement => (
	<div className="c-em-loader">
		<CTNSpinner size="size-48" />
		<p className="c-em-loader__titl">Enviando</p>
		<p className="c-em-loader__content">El proceso puede tardar unos minutos</p>
	</div>
);

export default Loader;
